import { FormCard } from "@/components/FormCard";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { newPasswordSchema } from "@/model/authSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useAuth } from "@/hooks/useAuth";
import { PasswordInput } from "@/components/PasswordInput";
import { useState } from "react";
import { PasswordRequirements } from "@/components/PasswordRequirements";
import { Button } from "@/components/ui/Button";
import { ArrowLeft } from "lucide-react";

type TNewPasswordSchema = z.infer<typeof newPasswordSchema>;

type NewPasswordFormProps = {
  defaultEmail: string;
  handleVerified: () => void;
  handleCancel: () => void;
};

export default function NewPasswordForm({
  defaultEmail,
  handleVerified,
  handleCancel,
}: NewPasswordFormProps) {
  const { handleConfirmNewPassword } = useAuth();
  const [isPasswordPopoverOpen, setIsPasswordPopoverOpen] = useState(false);

  const form = useForm<TNewPasswordSchema>({
    resolver: zodResolver(newPasswordSchema),
    // mode: "all",
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const onSubmit = async (data: TNewPasswordSchema) => {
    const { password } = data;
    const result = await handleConfirmNewPassword(
      password,
      form,
      handleVerified
    );
    console.log("result: ", result);
  };

  return (
    <FormCard
      form={form}
      onSubmit={onSubmit}
      title="New Password"
      description="A new password is required. Please set your new password to continue."
    >
      <div className="">
        <Button variant="link" onClick={handleCancel} className="">
          <ArrowLeft /> Back to Sign In
        </Button>
      </div>

      {/* <h3 className="flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50">
        Email
      </h3> */}
      <p className="text-white/80">{defaultEmail}</p>
      <FormField
        control={form.control}
        name="password"
        render={({ field }) => (
          <FormItem className="relative">
            <FormLabel>Password</FormLabel>
            <FormControl>
              <PasswordInput
                {...field}
                placeholder="********"
                onFocus={() => setIsPasswordPopoverOpen(true)}
                onBlur={() => setIsPasswordPopoverOpen(false)}
              />
            </FormControl>
            <FormMessage className="whitespace-pre-line" />
            {isPasswordPopoverOpen && (
              <PasswordRequirements password={form.watch("password")} />
            )}
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="confirmPassword"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Confirm Password</FormLabel>
            <FormControl>
              <PasswordInput placeholder="********" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <Button
        type="submit"
        className="w-full"
        disabled={form.formState.isSubmitting}
      >
        Confirm new Password
      </Button>
    </FormCard>
  );
}
